import React from "react"
import { motion } from "framer-motion"

const NameFilter = ({ value, onChange, placeholder = "" }) => {
  return (
    <motion.div
      className="mb-6 flex flex-col gap-[19px] relative"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <input
        type="text"
        value={value}
        onChange={(e) => onChange({ key: "name", value: e.target.value, overwrite: true })}
        placeholder={placeholder}
        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none"
      />
      {/* <div className="absolute -bottom-3 left-0 right-0 border-b border-light-gray/25" /> */}
    </motion.div>
  )
}

export default NameFilter
